import {
  ACHIEVEMENTS_PANEL,
  CABINET_PANEL,
  CATEGORY_PANEL,
  DAILY_PANEL,
  DICTIONARY_PANEL,
  HOME_PANEL,
  RATING_PANEL,
  TRAINING_PANEL,
  WORD_PANEL
} from '../routing/routing';

export const panelPaths = {
  [HOME_PANEL]: '/',
  [DAILY_PANEL]: '/daily',
  [TRAINING_PANEL]: '/training',
  [RATING_PANEL]: '/rating',
  [CABINET_PANEL]: '/cabinet',
  [DICTIONARY_PANEL]: '/dictionary',
  [ACHIEVEMENTS_PANEL]: '/achievements'
};

export const routeKeys = {
  home: HOME_PANEL,
  category: CATEGORY_PANEL,
  word: WORD_PANEL,
  daily: DAILY_PANEL,
  training: TRAINING_PANEL,
  rating: RATING_PANEL,
  cabinet: CABINET_PANEL,
  dictionary: DICTIONARY_PANEL,
  achievements: ACHIEVEMENTS_PANEL
};

export function parseIntParam(value) {
  const parsed = Number.parseInt(value || '', 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function panelToRouteKey(panel) {
  return Object.keys(routeKeys).find((key) => routeKeys[key] === panel) || 'home';
}

export function buildCategoryPath(categoryId) {
  return `/category/${categoryId}`;
}

export function buildWordPath(wordId, options = {}) {
  const params = new URLSearchParams();

  if (options.from) {
    params.set('from', options.from);
  }
  if (options.categoryId) {
    params.set('category_id', String(options.categoryId));
  }

  const query = params.toString();
  return `/word/${wordId}${query ? `?${query}` : ''}`;
}

export function buildTrainingPath(options = {}) {
  const params = new URLSearchParams();

  if (options.source) {
    params.set('source', options.source);
  }
  if (options.categoryId) {
    params.set('category_id', String(options.categoryId));
  }
  if (options.returnTo) {
    params.set('return_to', options.returnTo);
  }
  if (options.returnId) {
    params.set('return_id', String(options.returnId));
  }

  const query = params.toString();
  return `/training${query ? `?${query}` : ''}`;
}

export function resolvePanelPath(panel) {
  return panelPaths[panel] || '/';
}

export function resolveWordFallbackPath(searchParams) {
  const from = searchParams.get('from');
  if (from === 'category') {
    const categoryId = parseIntParam(searchParams.get('category_id'));
    if (categoryId > 0) {
      return buildCategoryPath(categoryId);
    }
  }

  return resolvePanelPath(routeKeys[from] || HOME_PANEL);
}

export function resolveTrainingFallbackPath(searchParams) {
  const returnTo = searchParams.get('return_to');
  const returnId = parseIntParam(searchParams.get('return_id'));

  if (returnTo === 'category' && returnId > 0) {
    return buildCategoryPath(returnId);
  }

  return resolvePanelPath(routeKeys[returnTo] || HOME_PANEL);
}
